export default function blockLogotypes() {

    if (document.querySelectorAll('.logotypes-slider:not(.logotypes-slider--disabled)').length === 0) {return;}

    import('swiper/bundle').then(({ default: Swiper }) => {
        document.querySelectorAll('.logotypes-slider:not(.logotypes-slider--disabled)').forEach(function(slider) {
            const swiper = new Swiper( slider, {
                speed: 1000,
                loop: true,
                spaceBetween: 2,
                autoplay: {
                    delay: 4000,
                    disableOnInteraction: true,
                },
                navigation: {
                    nextEl: slider.querySelector( '.logotypes-slider__arrow--next' ),
                    prevEl: slider.querySelector( '.logotypes-slider__arrow--prev' ),
                },
                breakpoints: {
                    0: {
                        slidesPerView: 3,
                    },
                    768: {
                        slidesPerView: 4,
                    },
                    1200: {
                        slidesPerView: 6,
                    },
                    1400: {
                        slidesPerView: 8,
                    },
                },
            } );
        });
    });
}
